import {
    GET_DISPOSITION_EQUIPMENT_CLASS,
    GET_DISPOSITION_PENALTY_FEE,
    SET_PENALTY_GLOBAL_FLAG,
    GET_PENALTY_GLOBAL_FLAG,
    GET_DISPOSITION_PENALTY_FEE_GRID_DATA,
    GET_DISPOSITION_TYPE,
    SET_DISPOSITION_EQUIPMENT_CLASS,
    SET_DISPOSITION_PENALTY_FEE,
    SET_DISPOSITION_PENALTY_FEE_GRID_DATA,
    SET_DISPOSITION_TYPE
} from "./DispositionPenaltyFeeType"

const getDispositionPenaltyFee = (assetDetailsForPenalty: any) => ({
    type: GET_DISPOSITION_PENALTY_FEE,
    assetDetailsForPenalty
});

const setDispositionPenaltyFee = (dispositionPenaltyFee: any) => ({
    type: SET_DISPOSITION_PENALTY_FEE,
    dispositionPenaltyFee: dispositionPenaltyFee
});

const getPenaltyGlobalFlag = () => ({
    type: GET_PENALTY_GLOBAL_FLAG
});

const setPenaltyGlobalFlag = (flag: boolean) => ({
    type: SET_PENALTY_GLOBAL_FLAG,
    globalPenaltyFlag: flag
});

const getDispositionPenaltyFeeGridData = (filterData: any) => ({
    type: GET_DISPOSITION_PENALTY_FEE_GRID_DATA,
    filterData
});

const setDispositionPenaltyFeeGridData = (gridData: any) => ({
    type: SET_DISPOSITION_PENALTY_FEE_GRID_DATA,
    gridData
});

const getDispositionEquipmentClass = () => ({
    type: GET_DISPOSITION_EQUIPMENT_CLASS
});

const setDispositionEquipmentClass = (dropdownData: any) => ({
    type: SET_DISPOSITION_EQUIPMENT_CLASS,
    dropdownData
});

const getDispositionType = () => ({
    type: GET_DISPOSITION_TYPE
});

const setDispositionType = (dropdownData: any) => ({
    type: SET_DISPOSITION_TYPE,
    dropdownData
});

export {
    getDispositionPenaltyFee,
    setDispositionPenaltyFee,
    getPenaltyGlobalFlag,
    setPenaltyGlobalFlag,
    getDispositionPenaltyFeeGridData,
    setDispositionPenaltyFeeGridData,
    getDispositionEquipmentClass,
    setDispositionEquipmentClass,
    getDispositionType,
    setDispositionType
}
